import React from 'react';
import './Switch.css';

type SwitchProps = {
    checked: boolean
    setChecked: (value: boolean) => void
}

export default function Switch({ checked, setChecked }: SwitchProps) {

    return (
        <div className="switch-container">
            <label className="switch">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={e => setChecked(e.target.checked)}
                />
                <span className="slider"></span>
            </label>
        </div>
    );
}